export default __webpack_public_path__ + "static/media/E-commerceRealCase1.b5b5e590.jpg";